<template>
  <div id="chekin-root">
    chekin
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import _ from 'lodash'
  import axios from 'axios'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import QRCode from 'qrcode'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'BGColor', 'FontSizeContent', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      }
    },
    watch: {
      data: {
        handler (newValue) {
          this.init()
        },
        deep: true
      },
    },
    mounted () {
      this.init()
      alert('aaa')
      var script= document.createElement('script')
      script.src = 'https://cdn.chekin.com/latest/ChekinPro.js'
      var head = document.getElementsByTagName("head")[0]
      head.insertBefore(script, head.firstChild)
      this.init()
    },
    methods: {
      init () {
        const apiKey = '5uAql3WT5OJWjNSpJf7EQX6yJg701dYw'
        console.log(apiKey)
        axios.get('https://api-ng.chekintest.xyz/public/api/v1/housings/', { headers: {"Authorization" : `Bearer ${apiKey}`} })
          .then(response => {
            console.log(response)
          })
          .catch(error => {
            console.log(error)
          })
        //axios.get('https://api-ng.chekintest.xyz/public/api/v1')
        /*
        const api = new ChekinHousingsSDK()

        api.initialize({
          apiKey: '__API_KEY__',
          housingId: '__CHEKIN_HOUSING_ID__',
          // externalHousingId: '__PMS_HOUSING_ID__',
        })

        api.renderApp({targetNode: 'chekin-root'})
        */
        /*
        const api = new ChekinPro()
        const reservationId = JSON.parse(localStorage.getItem('chekin-reservation-id')) || prompt("Enter a reservation id:")

        api.initialize({
          apiKey,
          reservationId,
          defaultLanguage: "es",
          canEditReservationDetails: true,
          enableGuestsRemoval: true,
          onGuestRegistered: (data) => console.log("GUEST:", data),
          onAllGuestsRegistered: (onAllGuestsRegistered) => console.log("All guests registered!", onAllGuestsRegistered),
          onReservationFound: (reservationFound) => console.log("reservationFound!", reservationFound),
          styles: `
            .chekin-button {
              background: #8BD609 ;
            }
          `,
          })
        api.renderApp({targetNode: 'chekin-root'})
        */
      },
    },
  }
</script>
